import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../Context/MyContext";
import { ContentPageSkeleton } from "../Components/Skeleton/Skeleton";
import PageLoadGate from "../Components/Skeleton/PageLoadGate";
import {
  formatMessage,
  resolveCarSpecValue,
  formatSpecDisplay,
} from "../../Utils/carSpecValue";
import { resolveImage } from "../../Utils/imageUtils";
import "./Compare.css";

export default function Compare() {
  const navigate = useNavigate();
  const context = useContext(MyContext);
  const {
    compare_page: page,
    compareIds,
    compareCars,
    removeFromCompare,
    clearCompare,
  } = context;

  const actions = page.actions || {};
  const specRows = page.specRows || [];
  const empty = page.empty || {};

  const subtitle = useMemo(
    () => formatMessage(page.subtitle, { max: page.maxCars }),
    [page.subtitle, page.maxCars]
  );

  if (!compareCars.length) {
    return (
      <PageLoadGate skeleton={<ContentPageSkeleton />} delay={380}>
        <div className="compare-page">
          <div className="compare-empty">
            <span className="compare-empty-icon">⚖️</span>
            <h1>{empty.title}</h1>
            <p>{empty.message}</p>
            <button
              type="button"
              className="compare-btn primary"
              onClick={() => navigate(empty.browsePath || "/cars")}
            >
              {empty.browseLabel}
            </button>
          </div>
        </div>
      </PageLoadGate>
    );
  }

  return (
    <PageLoadGate skeleton={<ContentPageSkeleton />} delay={380}>
      <div className="compare-page">
        <div className="compare-header">
          <div>
            <h1>{page.title}</h1>
            <p>{subtitle}</p>
          </div>
          <button type="button" className="compare-btn ghost" onClick={clearCompare}>
            {page.bar?.clearLabel}
          </button>
        </div>

        <div className="compare-table-wrap">
          <table className="compare-table">
            <tbody>
              {specRows.map((row) => (
                <tr key={row.key}>
                  <th>{row.label}</th>
                  {compareCars.map((car) => (
                    <td key={`${row.key}-${car.id}`}>
                      {row.type === "image" ? (
                        <img
                          src={resolveImage(resolveCarSpecValue(car, row, context))}
                          alt={car.id}
                          className="compare-car-img"
                        />
                      ) : (
                        formatSpecDisplay(resolveCarSpecValue(car, row, context), row)
                      )}
                    </td>
                  ))}
                </tr>
              ))}
              <tr>
                <th>{actions.removeLabel}</th>
                {compareCars.map((car) => (
                  <td key={`actions-${car.id}`}>
                    <div className="compare-cell-actions">
                      <button
                        type="button"
                        className="compare-btn small"
                        onClick={() => navigate(`/car/${car.id}`)}
                      >
                        {actions.viewDetailsLabel}
                      </button>
                      <button
                        type="button"
                        className="compare-btn small ghost"
                        onClick={() => removeFromCompare(car.id)}
                      >
                        {actions.removeLabel}
                      </button>
                    </div>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        <div className="compare-footer">
          <button
            type="button"
            className="compare-btn primary"
            onClick={() => navigate(actions.addMorePath || "/cars")}
          >
            {actions.addMoreLabel}
          </button>
        </div>
      </div>
    </PageLoadGate>
  );
}
